import script from "./BranchNoneDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./BranchNoneDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__